module.exports = __webpack_public_path__ + "static/media/together.2f8ccc4b.png";